import { PageLoadingIndicator } from '@wrisk/ui-components'
import React, { FunctionComponent, PropsWithChildren } from 'react'

import { useAuth } from '../../hooks/auth'
import { useErrorHandlingAsync } from '../../hooks/errors'
import { usePrincipal } from './PrincipalProvider'

const RedirectToSignIn: FunctionComponent = () => {
  const auth = useAuth()
  useErrorHandlingAsync(async () => await auth.signIn(), [])

  return <PageLoadingIndicator />
}

export const ProtectedRoutes: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = usePrincipal()
  return isAuthenticated ? <>{children}</> : <RedirectToSignIn />
}
